import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import ContatoTipoService from "../../services/ContatoTipoService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormContatoTipo extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idContatoTipo: "",
            nome: ""
        };

        this.state.crud = {
            service: ContatoTipoService,
            labels: {
                title: 'Tipo',
            },
            urlList: '/LstContatoTipo',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idContatoTipo} name="idContatoTipo" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Tipo" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormContatoTipo {...props} navigate={navigate} params={params} />
}

export default With